import { render, staticRenderFns } from "./GGSeal.vue?vue&type=template&id=a77b125a&scoped=true&"
import script from "./GGSeal.vue?vue&type=script&lang=js&"
export * from "./GGSeal.vue?vue&type=script&lang=js&"
import style0 from "./GGSeal.vue?vue&type=style&index=0&id=a77b125a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77b125a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a77b125a')) {
      api.createRecord('a77b125a', component.options)
    } else {
      api.reload('a77b125a', component.options)
    }
    module.hot.accept("./GGSeal.vue?vue&type=template&id=a77b125a&scoped=true&", function () {
      api.rerender('a77b125a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/GGSeal.vue"
export default component.exports